import { useState } from 'react'

/**
 * Page state for a client-paged DataTable, spreadable straight onto it:
 *
 *   const paging = useTablePaging()
 *   <DataTable rows={rows} {...paging} ... />
 *
 * The user data panels have a lot of small independent lists, and each needs its own page.
 */
export function useTablePaging(initialPageSize = 10) {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(initialPageSize)

  return { page, pageSize, onPageChange: setPage, onPageSizeChange: setPageSize }
}
